export const ACCESS_TOKEN_EXPIRATION_TIME = 60 * 24 * 7
export const REFRESH_TOKEN_EXPIRATION_TIME = 60 * 24 * 100
export const GOOGLE_ACCESS_TOKEN_EXPIRATION_TIME = 60
